export default {"src":"/_next/static/media/PaymentCategory.9ed29205.svg","height":24,"width":24,"blurWidth":0,"blurHeight":0};